import { render, staticRenderFns } from "./walletHistory.vue?vue&type=template&id=3870d4c8&scoped=true&"
import script from "./walletHistory.vue?vue&type=script&lang=js&"
export * from "./walletHistory.vue?vue&type=script&lang=js&"
import style0 from "./walletHistory.vue?vue&type=style&index=0&id=3870d4c8&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3870d4c8",
  null
  
)

export default component.exports